import { render, staticRenderFns } from "./ProductTypeSelect.vue?vue&type=template&id=9358b82c&"
import script from "./ProductTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./ProductTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports